import {
  GET_COOPERATION_APPRICANTS,
  GET_COOPERATION_APPRICANTS_BY_ID,
  REMOVE_COOPERATION_APPRICANTS,
} from "../actions/cooperation-appricants-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const cooperationAppricantsReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case (GET_COOPERATION_APPRICANTS.REQUEST,
    GET_COOPERATION_APPRICANTS_BY_ID.REQUEST,
    REMOVE_COOPERATION_APPRICANTS.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (GET_COOPERATION_APPRICANTS.SUCCESS,
    GET_COOPERATION_APPRICANTS_BY_ID.SUCCESS,
    REMOVE_COOPERATION_APPRICANTS.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (GET_COOPERATION_APPRICANTS.FAILURE,
    GET_COOPERATION_APPRICANTS_BY_ID.FAILURE,
    REMOVE_COOPERATION_APPRICANTS.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { cooperationAppricantsReducer };
